module.exports = __webpack_public_path__ + "img/img23.270e23ed.png";